import { z } from "zod";
export const customerOriginalOrderInitiationReceiptV1Schema = z
    .object({
    bookId: z.string().min(1).max(240),
    physicalOrderId: z.string().min(1).max(240).nullable(),
    receipt: z.enum(["RECORDED", "NOT_OBSERVED"]),
    truthBoundary: z.literal("RECEIPT_LOOKUP_NOT_PROVIDER_NON_ACCEPTANCE_OR_RESEND_PERMISSION"),
})
    .strict();
export const customerDeliveryDraftAddressV1Schema = z
    .object({
    recipientName: z.string().trim().min(1).max(50),
    line1: z.string().trim().min(1).max(35),
    line2: z.string().trim().min(1).max(35).optional(),
    city: z.string().trim().min(1).max(30),
    region: z.string().regex(/^[A-Z]{2}$/),
    postalCode: z.string().regex(/^\d{5}(?:-\d{4})?$/),
    country: z.literal("US"),
    phone: z.string().trim().min(7).max(25).optional(),
})
    .strict();
export const saveCustomerDeliveryDraftV1Schema = z
    .object({
    expectedVersion: z.number().int().nonnegative().nullable(),
    previewId: z.string().min(1).max(240),
    entitlementId: z.string().min(1).max(240),
    sourceRevision: z.number().int().nonnegative(),
    address: customerDeliveryDraftAddressV1Schema.nullable(),
})
    .strict();
export const customerDeliveryDraftV1Schema = saveCustomerDeliveryDraftV1Schema
    .omit({ expectedVersion: true })
    .extend({
    contract: z.literal("LC_CUSTOMER_DELIVERY_DRAFT_V1"),
    bookId: z.string().min(1).max(240),
    version: z.number().int().nonnegative(),
    initiationRequestKey: z.string().min(1).max(240),
    updatedAt: z.string().datetime({ offset: true }),
    expiresAt: z.string().datetime({ offset: true }),
    truthBoundary: z.literal("PRIVATE_DRAFT_NOT_ADDRESS_CONFIRMATION_OR_PRINT_SUBMISSION"),
})
    .strict();
//# sourceMappingURL=book-delivery-draft.js.map